
import Image from 'next/image'
import React, { forwardRef } from 'react'
import { BASE_URL } from '../../utils/FetchData'
import PhaseOverview from '../phase/PhaseOverview'
import FadeIn from '../Animations/FadeIn'
// eslint-disable-next-line react/display-name
const ProjectOverview = forwardRef(({ projectOverview, aboutProject }, ref) => {
    return (
        <>
            <div className={`project-overview-section ${aboutProject?.Show_In_Website?"custom-padding-bottom":""}`} ref={ref}>
                <FadeIn customClass='project-data'>
                    <span className='text-subtitle _eleX'>{projectOverview?.Headline}</span>
                    <h2 className='text-title light _eleX'>{projectOverview?.Header}</h2>
                    <p className='text-description _eleX'>{projectOverview?.Description}</p>
                </FadeIn>
                <FadeIn customClass='project-details'>
                    {projectOverview?.Project_Info?.map((pieceOfInfo, index) => (
                        <div className='icon-container _eleX' key={index}>
                            <div className='img-container'>
                                {pieceOfInfo?.Icon?.data?.attributes?.url && <Image
                                    src={BASE_URL + pieceOfInfo?.Icon?.data?.attributes?.url}
                                    alt={pieceOfInfo?.Icon?.data?.attributes?.url}
                                    layout="fill"
                                    objectFit="contain"
                                />}
                            </div>
                            <span>{pieceOfInfo?.Text}</span>
                        </div>
                    ))}
                </FadeIn>
            </div>
            {aboutProject?.Show_In_Website && <PhaseOverview
                title={aboutProject?.Title}
                description={aboutProject?.Description}
                usps={aboutProject?.Project_Usps}
                showSection={aboutProject?.Show_In_Website}
            />}
        </>
    )
})

export default ProjectOverview
